
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
  display:flex;
  width:100%;
  justify-content:center;
  margin-top:calc(var(--bh-footer-overlap-small) * -1);
}
  @media (min-width: 640px){:host {
    margin-top:calc(var(--bh-footer-overlap-medium) * -1);
  }
  }
  @media (min-width: 1280px){:host {
    margin-top:calc(var(--bh-footer-overlap-large) * -1);
  }
  }

.footer-super-wrapper {
  position:relative;
  width:100%;
  max-width:2000px;
}

.rounded-wrapper {
  position:absolute;
  display:block;
  height:100%;
  width:100%;
  overflow:hidden;
  padding:1rem;
}

@media (min-width: 640px) {
  .rounded-wrapper {
    padding:2rem;
  }
}

@media (min-width: 1024px) {
  .rounded-wrapper {
    padding:2.5rem;
  }
}

.rounded-wrapper svg{
    width:100%;
    height:auto;
  }

.footer-wrapper {
  margin-top:-0.25rem;
  background-color:var(--bh-brand-primary-default);
  color:var(--neutral-white);
}

.rounded {
  width:100%;
}

.rounded.big {
  display:none;
}

@media (min-width: 1280px) {
  .rounded.big {
    display:block;
  }
}

.rounded.medium {
  display:none;
}

@media (min-width: 640px) {
  .rounded.medium {
    display:block;
  }
}

@media (min-width: 1280px) {
  .rounded.medium {
    display:none;
  }
}

.rounded.small {
  margin-bottom:-20px;
}

.rounded.small {
  display:block;
}

.rounded.small {
  width:100%;
}

@media (min-width: 640px) {
  .rounded.small {
    display:none;
  }
}

.rounded svg {
  margin:0px;
}

.rounded svg {
  display:block;
}

.rounded svg {
  height:100%;
}

.rounded svg {
  width:100%;
}

.rounded-border {
  border-width:0px;
  border-bottom-width:1px;
  border-style:solid;
  border-bottom-color:var(--bh-brand-primary-light);
}

.rounded-border.big {
  display:none;
}

.rounded-border.big {
  height:100%;
}

.rounded-border.big {
  overflow:hidden;
}

@media (min-width: 1280px) {
  .rounded-border.big {
    display:block;
  }
}

.rounded-border.medium {
  display:none;
}

.rounded-border.medium {
  height:100%;
}

.rounded-border.medium {
  overflow:hidden;
}

@media (min-width: 640px) {
  .rounded-border.medium {
    display:block;
  }
}

@media (min-width: 1280px) {
  .rounded-border.medium {
    display:none;
  }
}

.rounded-border.small {
  display:block;
}

.rounded-border.small {
  height:100%;
}

.rounded-border.small {
  overflow:hidden;
}

@media (min-width: 640px) {
  .rounded-border.small {
    display:none;
  }
}

.footer-brand-logo {
  position:absolute;
  z-index:10;
  margin-top:-1.25rem;
  display:flex;
  width:100%;
  --tw-scale-x:.5;
  --tw-scale-y:.5;
  transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(.5) scaleY(.5);
  transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  justify-content:center;
  padding-top:0px;
}

@media (min-width: 640px) {
  .footer-brand-logo {
    margin-top:0px;
  }
  .footer-brand-logo {
    --tw-scale-x:.75;
    --tw-scale-y:.75;
    transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(.75) scaleY(.75);
    transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}

@media (min-width: 1024px) {
  .footer-brand-logo {
    --tw-scale-x:1;
    --tw-scale-y:1;
    transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1);
    transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .footer-brand-logo {
    padding-top:0.5rem;
  }
}

.footer {
  position:relative;
  z-index:20;
  padding-top:1.5rem;
  padding-bottom:1.5rem;
  padding-left:2rem;
  padding-right:2rem;
}

@media (min-width: 640px) {
  .footer {
    padding-top:6rem;
    padding-bottom:6rem;
  }
  .footer {
    padding-left:2.5rem;
    padding-right:2.5rem;
  }
  .footer {
    padding-bottom:3rem;
  }
}

@media (min-width: 1024px) {
  .footer {
    padding-left:4rem;
    padding-right:4rem;
  }
}

.footer .footer-top-supersection {
  display:flex;
}

.footer .footer-top-supersection {
  flex-direction:column-reverse;
}

@media (min-width: 1280px) {
  .footer .footer-top-supersection {
    flex-direction:row;
  }
}

@media (min-width: 1280px) {
  .footer .footer-top-supersection {
    justify-content:space-between;
  }
}

.footer .footer-logo-section {
  white-space:nowrap;
}

.footer .footer-logo-section {
  text-align:center;
}

.footer .footer-logo-section {
  font-family:var(--bh-ff-body);
}

.footer .footer-logo-section {
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}

@media (min-width: 640px) {
  .footer .footer-logo-section {
    text-align:left;
  }
}

@media (min-width: 1024px) {
  .footer .footer-logo-section {
    flex-grow:0;
  }
}

@media (min-width: 1024px) {
  .footer .footer-logo-section {
    padding-left:0px;
    padding-right:0px;
  }
}

.footer .footer-disclaimer-et-al-section {
  text-align:center;
}

@media (min-width: 640px) {
  .footer .footer-disclaimer-et-al-section {
    text-align:left;
  }
}

@media (min-width: 1024px) {
  .footer .footer-disclaimer-et-al-section {
    display:flex;
  }
}

@media (min-width: 1024px) {
  .footer .footer-disclaimer-et-al-section {
    justify-content:space-between;
  }
}

@media (min-width: 1024px) {
  .footer .footer-disclaimer-et-al-section {
    padding-left:0px;
    padding-right:0px;
  }
}

.footer .footer-links {
  margin-bottom:1rem;
}

.footer .footer-links {
  width:100%;
}

.footer .footer-links {
  font-family:var(--bh-ff-body);
}

@media (min-width: 1280px) {
  .footer .footer-links {
    margin-top:2rem;
  }
}

.footer .footer-contact {
  margin-top:0px;
}

.footer .footer-contact {
  display:flex;
}

.footer .footer-contact {
  flex-direction:column;
}

.footer .footer-contact {
  justify-content:space-between;
}

.footer .footer-contact {
  border-width:0px;
}

.footer .footer-contact {
  border-top-width:1px;
}

.footer .footer-contact {
  border-bottom-width:1px;
}

.footer .footer-contact {
  border-style:solid;
}

.footer .footer-contact {
  border-color:var(--bh-brand-primary-light);
}

.footer .footer-contact {
  padding-top:2rem;
}

.footer .footer-contact {
  padding-bottom:1rem;
}

.footer .footer-contact {
  font-family:var(--bh-ff-body);
}

@media (min-width: 640px) {
  .footer .footer-contact {
    margin-top:2rem;
  }
}

@media (min-width: 640px) {
  .footer .footer-contact {
    flex-direction:row;
  }
}

@media (min-width: 1280px) {
  .footer .footer-contact {
    margin-top:0px;
  }
}

@media (min-width: 1280px) {
  .footer .footer-contact {
    flex-direction:column;
  }
}

@media (min-width: 1280px) {
  .footer .footer-contact {
    border-width:0px;
  }
}

@media (min-width: 1280px) {
  .footer .footer-contact {
    padding-top:0px;
  }
}

@media (min-width: 1024px) {
  .footer .footer-contact-top {
    display:flex;
  }
}

@media (min-width: 1024px) {
  .footer .footer-contact-top {
    flex-direction:row;
  }
}

@media (min-width: 1024px) {
  .footer .footer-contact-top {
    gap:8rem;
  }
}

.footer .footer-contact-bottom {
  padding-top:2rem;
}

@media (min-width: 640px) {
  .footer .footer-contact-bottom {
    padding-top:0px;
  }
}

@media (min-width: 1280px) {
  .footer .footer-contact-bottom {
    padding-top:2rem;
  }
}

.footer .footer-contact-title {
  margin-bottom:0.5rem;
}

.footer .footer-contact-title {
  margin-top:0px;
}

.footer .footer-contact-title {
  font-family:var(--bh-ff-display);
}

.footer .footer-contact-title {
  font-size:var(--bh-fs-heading-04);
  line-height:var(--bh-lh-heading-04);
  letter-spacing:var(--bh-ls-heading-04);
}

.footer .footer-contact-title {
  font-weight:var(--fw-normal);
}

.footer .footer-contact-title {
  line-height:2.5rem;
}

.footer .footer-social-icons {
  margin-bottom:2rem;
}

.footer .footer-social-icons {
  display:flex;
}

.footer .footer-social-icons {
  flex-direction:row;
}

.footer .footer-social-icons {
  justify-content:center;
}

.footer .footer-social-icons {
  border-width:0px;
}

.footer .footer-social-icons {
  border-bottom-width:1px;
}

.footer .footer-social-icons {
  border-style:solid;
}

.footer .footer-social-icons {
  border-color:var(--bh-brand-primary-light);
}

.footer .footer-social-icons {
  padding-bottom:2rem;
}

@media (min-width: 640px) {
  .footer .footer-social-icons {
    margin-bottom:0px;
  }
}

@media (min-width: 640px) {
  .footer .footer-social-icons {
    display:block;
  }
}

@media (min-width: 640px) {
  .footer .footer-social-icons {
    border-width:0px;
  }
}

@media (min-width: 1280px) {
  .footer .footer-social-icons {
    padding-top:2rem;
  }
}

@media (min-width: 1280px) {
  .footer .footer-social-icons {
    padding-bottom:4rem;
  }
}

.footer .footer-privacy-policy, .footer .footer-terms-of-use, .footer .footer-contact-us {
  margin-left:auto;
  margin-right:auto;
}

.footer .footer-privacy-policy, .footer .footer-terms-of-use, .footer .footer-contact-us {
  margin-bottom:1.5rem;
}

.footer .footer-privacy-policy, .footer .footer-terms-of-use, .footer .footer-contact-us {
  font-family:var(--bh-ff-display);
}

.footer .footer-privacy-policy, .footer .footer-terms-of-use, .footer .footer-contact-us {
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.footer .footer-copyright {
  margin-bottom:2rem;
}

.footer .footer-copyright {
  font-family:var(--bh-ff-body);
}

@media (min-width: 1024px) {
  .footer .footer-copyright {
    text-align:left;
  }
}

.footer .footer-btt {
  margin-bottom:1rem;
}

.footer .footer-btt {
  display:block;
}

.footer .footer-btt {
  width:100%;
}

.footer .footer-btt {
  font-family:var(--bh-ff-body);
}

@media (min-width: 640px) {
  .footer .footer-btt {
    display:flex;
  }
}

@media (min-width: 640px) {
  .footer .footer-btt {
    width:400px;
  }
}

@media (min-width: 1280px) {
  .footer .footer-btt {
    width:150px;
  }
}

@media (min-width: 1024px) {
  .footer .footer-btt {
    margin-bottom:0px;
  }
}

@media (min-width: 1024px) {
  .footer .footer-btt {
    justify-content:flex-end;
  }
}

@media (min-width: 1024px) {
  .footer .footer-btt {
    text-align:right;
  }
}

.footer .footer-btt {
  align-items:center;
}

@media (min-width: 1280px) {
  .footer .footer-btt {
    align-items:flex-start;
  }
}

.footer .footer-btt {
  margin-top:0px;
}

@media (min-width: 1280px) {
  .footer .footer-btt {
    margin-top:2.5rem;
  }
}

.footer-run-wrapper .footer-wrap {
  display:flex;
}

.footer-run-wrapper .footer-wrap {
  flex-direction:column;
}

.footer-run-wrapper .footer-wrap {
  align-items:center;
}

.footer-run-wrapper .footer-contact {
  margin:0px;
}

.footer-run-wrapper .footer-contact {
  border-width:0px;
}

.footer-run-wrapper .footer-contact {
  padding:0px;
}

.footer-run-wrapper .footer-social-icons {
  border-width:0px;
}

.footer-run-wrapper .footer-social-icons {
  padding:0px;
}

.footer-run-wrapper .footer-social-icons {
  margin-bottom:1rem;
}

@media (min-width: 1280px) {
  .footer-run-wrapper .footer-social-icons {
    margin-bottom:0px;
  }
}

.footer-run-wrapper .footer-btt {
  width:auto;
}

.footer-run-wrapper .footer-btt {
  align-self:center;
}

@media (min-width: 1024px) {
  .footer-run-wrapper .footer-btt {
    align-self:flex-end;
  }
}

.footer-run-wrapper .footer-btt {
  margin-top:1.25rem;
}

@media (min-width: 1280px) {
  .footer-run-wrapper .footer-btt {
    margin-top:0px;
  }
}

.footer-run-wrapper .footer {
  padding-top:5rem;
}

.footer-run-wrapper .footer-contact-bottom {
  padding:0px;
}
`;